<template>
  <div class="table-action-wrapper">
    <a class="mb-2 mr-2 btn btn-outline-success" href="#" @click.prevent="handleAction('PrintArtwork')">Print Artwork</a>
    <div class="main-table-action w-100">
      <component :key="loaded" :is="view" :config="configAction" @changeFilters="handleChangeFilters"></component>
    </div>
  </div>
</template>
<script>
import * as components from './Action/'
export default {
  components: components,
  data() {
    return {
      loaded: 0,
      view: false
    }
  },
  computed: {
    configAction() {
      return this.config
    }
  },
  methods: {
    handleAction(action) {
      this.view = action in this.$options.components ? action : false
      this.loaded++
    },
    handleChangeFilters(query, args) {
      this.$emit('change-filters', query, args)
    }
  },
  props: {
    config: Object
  }
}
</script>
